import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '../date-range-picker/ngb-date-parser-formatter';
import { RootScopeDeclare } from '../rootscope-declare';
import { CommonUtil } from '../Utils/common-util';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
   ]
})
export class DatepickerComponent implements OnInit {
  model: NgbDateStruct;
  mobMinDate: string;
  mobileModel: string;
  defaultDate: NgbDateStruct;
  rootScopeData: RootScopeDeclare;

  @Input() label: string;
  @Input() isShowLabel = true;
  @Input() dateValue: string | number;
  @Output() currentDate = new EventEmitter();

  constructor(private config: NgbInputDatepickerConfig,
    private _commonUtil: CommonUtil
  ) {
  }

  ngOnInit(): void {
    this.rootScopeData = this._commonUtil.rootScopeData;
    if (this.rootScopeData.deviceType=="phone" || this.rootScopeData.deviceType=="tablet") {
      this.config.autoClose = false;
    }
    
    let _today = new Date();
    this.config.minDate = { year: _today.getFullYear(), month: _today.getMonth() + 1, day: _today.getDate() };

    _today.setDate(new Date().getDate() + 1);
    if(this.dateValue) _today = new Date(this.dateValue);
    this.defaultDate = { year: _today.getFullYear(), month: _today.getMonth() + 1, day: _today.getDate() };

    this.config.container = 'body';
    this.config.showWeekdays = true;
    this.config.navigation = "arrows";
    this.config.startDate = { year: _today.getFullYear(), month: _today.getMonth() + 1 };
    this.model = this.defaultDate;
    this.update();
  }

  dateSelect() {
    if (this.model && this.model.day) {
      this.update();
    }
  }

  update() {
    this.currentDate.emit(this.model);
  }
}
